<div class="d-flex flex-column justify-content-center align-items-center mt-4">
  <div class="spinner-border text-primary mb-2" role="status">
    <span class="visually-hidden"></span>
  </div>
  <div class="fw-bold">{{ mensaje }}</div>
</div>
